import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  navTrees: { system: [], org: [], loading: false },
  imgList: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  conditions: [],
  onlyMobileAsset: false,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
